module.exports = __webpack_public_path__ + "img/V49.f9309cf9.jpg";